import { autoinject } from "aurelia-dependency-injection";
import { WebAuth } from "auth0-js";
import { ConfigService } from "./config.service";
import { RequestClientService } from "./request-client.service";

@autoinject()
export class AuthenticationService {

    public redirectUri: string;
    public clientId: string;
    public auth0: WebAuth;
    
    constructor(private configService: ConfigService, private requestClient: RequestClientService) {
        this.redirectUri = this.configService.config.common.auth0Settings.redirectUri;
        this.clientId = this.configService.config.common.auth0Settings.clientId;
        this.auth0 = new WebAuth({
            domain: this.configService.config.common.auth0Settings.domain,
            clientID: this.clientId,
            redirectUri: this.redirectUri,
            audience: this.configService.config.common.auth0Settings.audience,
            responseType: 'token id_token',
            scope: 'openid email profile app_metadata user_metadata'
        });
    
    } 

    public logOut() {
        return new Promise<void>((resolve, reject) => {
            this.requestClient.post<void>(`${this.configService.config.urls.rightShipPlatformApiUrl}/api/v1/token/logout`, {}).then(() => {
                const redirectUrl = `${this.configService.config.urls.rightShipPlatformUrl}/auth0-login`;
                const logoutOptions = { clientID: this.clientId, returnTo: redirectUrl, federated: true};
                this.auth0.logout(logoutOptions);
                resolve();
            }, () => {
                reject();
            });

            // this.cacheClient.remove('auth0_access_token', CacheLocation.LocalStorage).then(() => {
            //     // resolve(); commented out as it was not allowing logout to happen properly, this.auth0.logout redirects when done and its return type is void so cannot be awaited
            // })
            // .catch((e) =>{
            //     // this.auth0.logout(logoutOptions);
            //     reject(e);
            // });
        })
    }
}